import { removeEmptyFields } from '@/utils/format';
import { AnyRoute, useNavigate, useRouterState, useSearch } from '@tanstack/react-router';

type UseSearchParamsReturn<T> = {
  search: T;
  setSearchParams: (values: Partial<T>) => void;
  resetSearchParams: () => void;
};

export const useSearchParams = <T>(): UseSearchParamsReturn<T> => {
  const navigate = useNavigate();
  const routerState = useRouterState();
  const search = useSearch<AnyRoute, true, boolean, T>({
    strict: false,
  });

  // @todo: remove the any type
  const setSearchParams = (values: Partial<T> | any) => {
    values.page = 1;
    navigate({ search: removeEmptyFields(values) });
  };

  const resetSearchParams = () => {
    navigate({ to: routerState.location.pathname, search: {}, params: {} });
  };

  return { search, setSearchParams, resetSearchParams };
};
